<script lang="ts">
    import { initRecentlyUsedStore } from "./RecentlyViewed.service";
    import RecentlyViewedTranslationsPage from "./RecentlyViewedTranslationsPage.svelte";
    import RecentlyViewedTranslationsPresenter from "./RecentlyViewedTranslationsPresenter.svelte";
    const recentlyViewedTranslationsContainers = Array.from(
        document.querySelectorAll<Element>(
            '[data-sv="recentlyViewedTranslations"]'
        )
    );
    recentlyViewedTranslationsContainers.forEach((container) => {
        new RecentlyViewedTranslationsPresenter({
            target: container,
        });
    });

    const recentlyViewedPageContainer = document.getElementById("recentlyViewedTranslationsPage");

    if (recentlyViewedPageContainer) {
        new RecentlyViewedTranslationsPage({
            target: recentlyViewedPageContainer
        })
    }
    initRecentlyUsedStore();
</script>
